import React, { useState } from 'react';
import { Modal, Button, Form, Table, Alert } from 'react-bootstrap';

const BarcodeModal = ({ show, handleClose, onSave, productName, requiredQuantity }) => {
  const [barcodeInput, setBarcodeInput] = useState('');
  const [barcodes, setBarcodes] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleAddBarcode = () => {
    if (!barcodeInput.trim()) {
      setError('Barcode cannot be empty');
      return;
    }

    // Check for duplicates
    if (barcodes.includes(barcodeInput.trim())) {
      setError('Barcode already added');
      return;
    }

    setBarcodes([...barcodes, barcodeInput.trim()]);
    setBarcodeInput('');
    setError('');
  };

  const handleRemoveBarcode = (index) => {
    setBarcodes(barcodes.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    if (barcodes.length === 0) {
      setError('Please add at least one barcode');
      return;
    }

    if (requiredQuantity && barcodes.length !== requiredQuantity) {
      setError(`Siz ${barcodes.length} ta barcode qo'shdiz, lekin ${requiredQuantity} ta kerak`);
      return;
    }

    onSave(barcodes);
    setSuccess('Barcodes saved successfully!');
    setTimeout(() => {
      handleClose();
      setBarcodes([]);
      setBarcodeInput('');
      setError('');
      setSuccess('');
    }, 1000);
  };

  const handleCloseModal = () => {
    setBarcodes([]);
    setBarcodeInput('');
    setError('');
    setSuccess('');
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleCloseModal} size="lg" backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Barcode qo'shish - {productName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}
        
        <Form.Group className="mb-3">
          <Form.Label>Barcode kiriting</Form.Label>
          <div className="d-flex">
            <Form.Control
              type="text"
              value={barcodeInput}
              onChange={(e) => setBarcodeInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleAddBarcode()}
              placeholder="Barcode kiriting va Enter bosing"
            />
            <Button 
              variant="primary" 
              onClick={handleAddBarcode}
              className="ms-2"
            >
              Qo'shish
            </Button>
          </div>
        </Form.Group>

        {requiredQuantity && (
          <Alert variant="info" className="mt-3">
            <strong>Eslatma:</strong> Bu mahsulot uchun {requiredQuantity} ta barcode kerak
          </Alert>
        )}
        
        {barcodes.length > 0 && (
          <div className="mt-3">
            <h6>Qo'shilgan barcodes ({barcodes.length}{requiredQuantity ? `/${requiredQuantity}` : ''}):</h6>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Barcode</th>
                  <th>Amallar</th>
                </tr>
              </thead>
              <tbody>
                {barcodes.map((barcode, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{barcode}</td>
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleRemoveBarcode(index)}
                      >
                        O'chirish
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          Bekor qilish
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Saqlash
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BarcodeModal; 